"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAssetFileName = void 0;
var realms_three_utils_1 = require("realms-three-utils");
/**
 * Gets the generated asset filename
 */
var getAssetFileName = function (asset) {
    var _a;
    // Encode as base64 for the prefix
    var safeIdPrefix = btoa(asset.id);
    if ((0, realms_three_utils_1.isAsset3DFileType)(asset.type)) {
        return (asset.name.replace(".".concat(asset.type), "") +
            "-".concat(safeIdPrefix, ".").concat(asset.type));
    }
    var ext = "." + ((_a = asset.type.split("/")[1]) !== null && _a !== void 0 ? _a : "");
    return asset.name.replace(ext, "") + "-".concat(safeIdPrefix).concat(ext);
};
exports.getAssetFileName = getAssetFileName;
